// extracted by mini-css-extract-plugin
export var banner = "_2o-0";
export var icon = "_2o-1";
export var message = "_2o-2";